module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAiCAYAAADcbsCGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJNJREFUeNrsmLEJgDAURH/EWmwcQbS0dACHcgLJNE5gr6WlO1ipA8SztRMRTriDR8o8Eu4H4kIIhuTAgwYkRpIYFGACqZElAh2j2BWHa92YrvIuF4w0kRFHcpKT3O2FeJzKr683ntvs3yenIaxCqBAqhAqhQqgQkpOc5D6V25nlBuYhXGIdjfQLbAE16MHBJHcKMABGHSseqpaTNwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/MENU_V.png
// module id = HRIS
// module chunks = 18